import React from 'react';
type LogoProps = {
  variant?: 'dark' | 'light';
  showTagline?: boolean;
};
export function Logo({
  variant = 'dark',
  showTagline = true
}: LogoProps) {
  const wordColor = variant === 'dark' ? 'text-white' : 'text-ardis-green';
  const taglineColor = variant === 'dark' ? 'text-white/70' : 'text-slate-500';
  return <a href="#accueil" className="flex items-center gap-2 group" aria-label="A.D. INTER - Startpagina" data-id="element-114" data-mp="3v9phwpu1vzd4">
      <svg viewBox="0 0 40 32" className="h-8 w-9 flex-shrink-0" aria-hidden="true" fill="none" data-id="element-115" data-mp="mtnnqgvrvejt">
        <path d="M4 30 L16 6 L22 18 L28 10 L36 30 Z" fill="#dc2626" data-id="element-116" data-mp="dsg331m6ic87" />
        <path d="M18 30 L27 12 L36 30 Z" fill="#166534" data-id="element-117" data-mp="du915siq7o4l" />
      </svg>
      <div className="flex flex-col leading-none" data-id="element-118" data-mp="hsggqk1geje7">
        <span className={`font-display text-2xl font-extrabold tracking-tight ${wordColor}`} data-id="element-119" data-mp="2yiexe8aawmsc">
          A.D. INTER
        </span>
        {showTagline && <span className={`text-[10px] font-medium tracking-wide ${taglineColor}`} data-id="element-120" data-mp="32hw4t79afu05">
            De keuze, kwaliteit, voor de beste prijs
          </span>}
      </div>
    </a>;
}